import { resolveLanguage } from './config'

/**
 * API 요청에 붙일 Accept-Language 값.
 *
 * 이 헤더를 보내지 않으면 브라우저 언어가 응답 언어를 정한다. 화면에서 고른
 * 언어와 어긋나, 영어 화면에 한국어 기능명이 섞여 나오던 문제가 있었다.
 */
export function requestLanguageHeader(language?: string | null): string {
  return resolveLanguage(language)
}

export default requestLanguageHeader
